import { render, staticRenderFns } from "./SizeUnitField.vue?vue&type=template&id=e14620fe&"
import script from "./SizeUnitField.vue?vue&type=script&lang=ts&"
export * from "./SizeUnitField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports